import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';
import _ from 'lodash';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';

if (globalThis.config.IS_SENTRY_ENABLED) {
	Sentry.init({
		dsn: globalThis.config.SENTRY_PUBLIC_DSN,
		release: globalThis.config.VERSION,
		environment: globalThis.config.ENVIROMENT,
		beforeSend(event: Sentry.ErrorEvent, hint: Sentry.EventHint) {
			const error = hint.originalException;

			if (error instanceof AxiosError && error?.status && error.status < 500) {
				return null;
			}
			// remove cookies before sending data to sentry as they are used for authentication
			_.unset(event, 'request.headers.cookie');
			_.unset(event, 'request.cookies');

			// remove the body on rest requests to not leak potentially sensitive data
			_.unset(event, 'request.data');

			event.tags = {
				environment: globalThis.config.ENVIROMENT,
				location: 'frontend',
				requestId: _.get(event, 'request.headers.x-tradeshift-requestid'),
				cardProvider: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? 'AMEX' : 'HSBC',
			};
			return event;
		},
		integrations: [
			// See docs for support of different versions of variation of react router
			// https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			Sentry.replayIntegration(),
		],
	});
}
